// 埋点
export const TaLog = function (param) {
  if (typeof window.TA != 'undefined' && param.id) {
    console.log($t("f93d7233ea"), param);
    param._sid = Date.now();
    window.TA.log(param);
  } else {
    console.log($t("7b317dc923"), param);
  }
};
export const dateformatter = function (date, fmt) {
  if (!date || !(date instanceof Date)) return '';
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth + 3) / 3),
    // 季度
    'S+': date.getMilliseconds() // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substring(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substring(('' + o[k]).length));
    }
  }
  return fmt;
};
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) {
    return unescape(res[2]);
  } else {
    return null;
  }
}
// export function getMonthDay(year, month) {
//     return new Date(year, month + 1, 0).getDate();
// }

// export function numFormatter(num, isInt = false) {
//     if (isNaN(num)) {
//         return num;
//     } else {
//         if (isInt) {
//             return `${Number.parseInt(num).toLocaleString()}`
//         }
//         let res = `${Number(num).toLocaleString()}`; // 千分
//         const splitByDecp = res.split('.');
//         res = splitByDecp[0] + '.';
//         if (splitByDecp.length === 1) {
//             res += '00';
//         } else {
//             const decNum = splitByDecp[1] + '00';
//             res += decNum.substring(0, 2);
//         }
//         return res;
//     }
// }
export const uniqueArr = function (arr) {
  let result = [];
  arr.forEach(item => {
    if (!result.some(m => m.id === item.id)) {
      result.push(item);
    }
  });
  return result;
};
export const throttle = function (func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function () {
    previous = options.leading === false ? 0 : new Date();
    timeout = null;
    result = func.apply(context, args);
  };
  return function () {
    var now = new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};
export const debounce = function (func, wait, immediate) {
  let timeout, args, context, timestamp, result;
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
};
export const getCookie = function (n) {
  var a,
    r = new RegExp("(^| )" + n + "=([^;]*)(;|$)");
  try {
    if (a = document.cookie.match(r)) {
      return decodeURIComponent(a[2]);
    } else {
      return "";
    }
  } catch (e) {
    return "";
  }
};

export const WinAPI = (apiName, params, callback) => {
  if (window.API) {
      console.log('客户端调用', JSON.stringify({ name: apiName, params}));
      try {
          window.API.use(
              apiName,
              params,
          );
      } catch (e) {
          console.error('客户端调用失败');
      }
  } else {
      console.log('请在客户端内调用', JSON.stringify({ name: apiName, params}));
  }
}